import { render, staticRenderFns } from "./slider.pug?vue&type=template&id=d31dcf98&lang=pug&external"
import script from "./slider.js?vue&type=script&lang=js&external"
export * from "./slider.js?vue&type=script&lang=js&external"
import style0 from "./slider.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d31dcf98')) {
      api.createRecord('d31dcf98', component.options)
    } else {
      api.reload('d31dcf98', component.options)
    }
    module.hot.accept("./slider.pug?vue&type=template&id=d31dcf98&lang=pug&external", function () {
      api.rerender('d31dcf98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/slider/index.vue"
export default component.exports